<ng-container *ngLet="showTopBanner$ | async as showTopBanner">
	<ng-container *ngLet="showBottomBanner$ | async as showBottomBanner">
		<ng-container
			*ngLet="cookiesConsentService.isConsented | async as isConsented"
		>
			<div class="page-container {{ !isConsented ? 'consented' : '' }}">
				<app-header
					[class.oeg]="currentlegalPageState === LegalPageState.Oeg"
					[class.silvertec]="currentlegalPageState === LegalPageState.Silvertec"
					[showBannerOnly]="showTopBanner"
				></app-header>
				<div class="page-content">
					<ng-content></ng-content>
				</div>
				<app-footer
					[showBannerOnly]="showBottomBanner"
					*ngIf="
						currentlegalPageState !== LegalPageState.Oeg &&
						currentlegalPageState !== LegalPageState.Silvertec
					"
				></app-footer>
			</div>
			<app-cookies-consent
				[class.oeg]="currentlegalPageState === LegalPageState.Oeg"
				[class.silvertec]="currentlegalPageState === LegalPageState.Silvertec"
				*ngIf="!isConsented"
			></app-cookies-consent>
		</ng-container>
	</ng-container>
</ng-container>
